function init() {
	const forms = document.querySelectorAll<HTMLFormElement>('form[data-captcha-enabled="1"]');
	forms.forEach(form => {
		const action = form.dataset.captchaAction ?? '';
		const siteKey = form.dataset.captchaKey ?? '';
		const input = form.querySelector<HTMLInputElement>('input[name="recaptcha_token"]');
		if (action === '' || siteKey === '' || !input) {
			return;
		}

		let isSubmitting = false;

		form.addEventListener('submit', function(e) {
			if (isSubmitting) {
				return;
			}

			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			isSubmitting = true;

			grecaptcha.enterprise.ready(async function() {
				try {
					input.value = await grecaptcha.enterprise.execute(siteKey, {action: action});
					form?.requestSubmit();
					isSubmitting = false;
				} catch (err) {
					console.error('Recaptcha error:', err);
				}
			});
		});
	});
}

init();
